import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowLeft,
  faBookmark,
  faCheckSquare,
  faChevronDown,
  faChevronUp,
  faExclamationTriangle,
  faFilter as farFilter,
  faInfoCircle,
  faQuestionCircle,
  faSearch,
  faSquare,
  faTimes,
  faUserMd
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBookmark as fasBookmark,
  faCaretUp,
  faCaretDown,
  faComment,
  faFlag,
  faFilter,
  faSave
} from '@fortawesome/pro-solid-svg-icons';

const ICONS = Object.freeze({
  BACK: faArrowLeft,
  BOOKMARK_ACTIVE: fasBookmark,
  BOOKMARK_INACTIVE: faBookmark,
  CARET_UP: faCaretUp,
  CARET_DOWN: faCaretDown,
  CHART_ASSIST: faUserMd,
  CHECK_FALSE: faSquare,
  CHECK_TRUE: faCheckSquare,
  CLOSE: faTimes,
  CHEVRON_DOWN: faChevronDown,
  CHEVRON_UP: faChevronUp,
  FILTER_INACTIVE: farFilter,
  FILTER_ACTIVE: faFilter,
  FEEDBACK: faComment,
  FLAG: faFlag,
  HINT: faInfoCircle,
  INFO: faQuestionCircle,
  SAVE: faSave,
  SEARCH: faSearch,
  WARNING: faExclamationTriangle
});

library.add(...Object.values(ICONS));
export { ICONS };
